import { Component } from '@angular/core';
import { MethodBase } from '../base/method-base';
import { AuthMethodViewModel } from '../../../../services/identity';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-method-password',
    templateUrl: './password.component.html',
    styleUrl: './password.component.scss',
    imports: [TranslatePipe]
})
export class PasswordComponent extends MethodBase {

  override ngOnInit(): void {
    this.formStatusChanged.emit({ sequence: this.method.sequence, index: 0, status: 'VALID', touched: this.isEditing });
    super.ngOnInit();
  }

  setup(): void {

  }

  cancel(): AuthMethodViewModel {
    return this.method;
  }
  getMethod(): AuthMethodViewModel {
    return this.method;
  }

}
